import { mapState, mapActions } from 'vuex'

export default {
  name: 'ServiceTypeSelectButton',
  props: {
    name: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      'default': () => 0
    },
    model: {
      type: Array,
      require: false,
      'default': () => []
    },
    disabled: {
      type: Boolean,
      require: false,
      'default': () => false
    }
  },
  data () {
    return {
      loading: true
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      buttonId: state => state.selectServiceTypeModal.buttonId,
      value: state => state.selectServiceTypeModal.value,

      // model
      serviceTypeModel: state => state.selectServiceTypeModal.serviceTypeModel,
    }),

    results () {
      if (this.loading) return ''
      // console.log('value', this.value)
      // サービスタイプ名を取得
      try {
        // return this.value.map(id => this.serviceTypeModel.filter(item => item.serviceTypeCd == id)[0].serviceTypeName).join('、')
        return this.value.map(item => item.serviceTypeName).join('、')
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // showDeleteButton () {
    //   return this.model ? true : false
    // }
  },
  watch: {
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to && this.buttonId === this.name) {
        // console.log(this.name, to)
        this.changeValue(to)
      }
    },
    model (to) {
      // 初期データを格納
      this.setValue(this.model)
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'selectServiceTypeModal/loadModel',
      showModal: 'selectServiceTypeModal/show',
      setValue: 'selectServiceTypeModal/setValue'
    }),

    init () {
      // 初期データを格納
      this.setValue(this.model)

      // RSS取得のためデータ読出
      this.loading = true

      //
      let serviceTypeParams = {}

      // データ読出し
      this.loadModel({
        serviceTypeParams: serviceTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    showSelector () {
      this.showModal({
        buttonId: this.name,
        data: this.value
      })
    },

    changeValue (data) {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        data: data
      })
    },
    // deleteScreen () {
    //   this.$emit('childs-delete', {
    //     name: this.name,
    //     index: this.index
    //   })
    // }
  }
}